import logo from "assets/images/logo-bn.png";
import flow from "lodash/flow";
import { Children, useState } from "react";
import { ArrowDownCircleFill, CheckCircle } from "react-bootstrap-icons";
import { PrimaryButton } from "../../../../components/buttons/buttons";
import Modal from "../../../../components/modals/modal/modal";
import { currencyFormat, nullary } from "../../../../core/utils";
import { ModalProps } from "../../../../core/utils/modals";
import { ActionHandler } from "../../../../types";
import { DatosComprobante } from "../types/pagos.types";
import "./pago-autorizado.modal.scss";

export type PagoAutorizadoModalProps = ModalProps & {
	datos?: Partial<DatosComprobante>;
	permiteDomiciliar: boolean;
	descargarComprobante: VoidFunction;
	onContinue?: ActionHandler<boolean>;
};

const PagoAutorizadoModal = ({ parent, onClosed, onContinue, datos = {}, descargarComprobante, permiteDomiciliar }: PagoAutorizadoModalProps) => {
	const [domiciliar, setDomiciliar] = useState(false);

	const changeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
		setDomiciliar(e.target.checked);
	};

	const closeHandler = () => {
		!domiciliar && onClosed?.();
	};

	const continuar = () => {
		onContinue?.(domiciliar);
	};

	const footer = (close: VoidFunction) => (
		<PrimaryButton className="ml-5" onClick={flow(continuar, close)}>Continuar</PrimaryButton>
	);

	return (
		<Modal parent={parent} title="" dialogClassName="pago-autorizado" footer={footer} onClosed={closeHandler}>
			<div className="col-12">
				<div className="comprobante-banorte" style={{ width: 1100 }}>
					<div className="c-header">
						<img src={logo} alt="alt" height="60px" />
					</div>
					<div className="c-body">
						<div className="c-b-success">
							<div className="e-title">
								<span>El pago ha sido autorizado</span>
							</div>
							<div className="s-icon">
								<CheckCircle height="80" width="80"></CheckCircle>
							</div>
						</div>
						<div className="row">
							<div className="col-9">
								<table className="border-b">
									<tbody>
										<tr>
											<td>Empresa:</td>
											<td>{datos.nombre}</td>
										</tr>
										<tr>
											<td>RFC de la empresa:</td>
											<td>{datos.rfc}</td>
										</tr>
										<tr>
											<td>Fecha de operación:</td>
											<td>{datos.fechaOperacion}</td>
										</tr>
										<tr>
											<td>Hora de operación:</td>
											<td>{datos.horaOperacion}</td>
										</tr>
										<tr>
											<td>Forma de pago:</td>
											<td>{datos.formaPago}</td>
										</tr>
										<tr>
											<td>Cuenta origen:</td>
											<td>{datos.cuentaOrigen}</td>
										</tr>
										<tr>
											<td>Cuenta destino:</td>
											<td>{datos.cuentaDestino}</td>
										</tr>
										<tr>
											<td>Banco destino:</td>
											<td>{datos.bancoDestino}</td>
										</tr>
										<tr>
											<td>Importe:</td>
											<td>{currencyFormat(datos.importe ?? 0)} MN</td>
										</tr>
										<tr>
											<td>ID de cobro:</td>
											<td>
												{Children.toArray(datos.referencias?.map(referencia =>
													<>{referencia}<br /></>
												))}
											</td>
										</tr>
										<tr>
											<td>Concepto de pago:</td>
											<td>
												{Children.toArray(datos.conceptos?.map((concepto, i) =>
													<>{concepto}<br /></>
												))}
											</td>
										</tr>
										<tr>
											<td>Clave de rastreo:</td>
											<td>{datos.claveRastreo}</td>
										</tr>
										<tr>
											<td>Referencia de pago:</td>
											<td>{datos.referenciaPago}</td>
										</tr>
									</tbody>
								</table>
							</div>
							<div className="col-3 m-auto">
								<span className="l-comprobante">Obtén tu comprobante de pago</span>
								<div className="b-download" onClick={nullary(descargarComprobante)}>
									<div>
										<ArrowDownCircleFill height="40" width="40"></ArrowDownCircleFill>
									</div>
									<span>Descargar</span>
								</div>
								<div className="col-12">
									<div className="form-check-control mb-2">
										<div className="col-sm-12">
											{permiteDomiciliar &&
												<div>
													<input
														type="checkbox"
														className="form-check-input"
														onChange={changeHandler}
													/>
													<label className="form-check-label">Deseo domiciliar mi pago</label>
												</div>
											}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					{/*<div className="c-footer">*/}
					{/*	<div className="col-12 text-end">*/}
					{/*		<PrimaryButton className="me-5">Continuar</PrimaryButton>*/}
					{/*	</div>*/}
					{/*</div>*/}
				</div>
			</div>
		</Modal>
	);
};

export default PagoAutorizadoModal;